export default (state,getters)=>({bonuses,direction,c_type})=>{
    return getters.list.filter(i => {
        if (!bonuses && i.bonuses) return false;
        if (direction && direction !== i.direction) return false;
        if (c_type) {
            switch (c_type) {
                case 1:
                case 2:
                    if (!i.operationType) return false;
                    if (i.value === 5) return false;
                    if (i.value === 6) return false;
                    if (i.value === 9) return false;
                    if (i.value === 10) return false;
                    break;
                case 3:
                    if (i.value === 1) return false;
                    if (i.value === 2) return false;
                    if (i.value === 3) return false;
                    if (i.value === 4) return false;
                    if (i.value === 7) return false;
                    if (i.value === 8) return false;
                    if (!i.operationType) return false;
                    break;
                case 5:
                    if (i.operationType) return false;
                    break;
                case 6:
                    if (i.operationType) return false;
                    break;
                case 7:
                    if (!i.operationType) return false;
                    break;
                case 'client':
                    break;
                case 'partner':
                    break;
            }
        }
        return true;
    })
}